// extracted by mini-css-extract-plugin
export default {"Container":"Wishlist_Container__coHEg"};